import { type ActionFunctionArgs, json } from "@remix-run/cloudflare";
import { Buffer } from 'node:buffer';
import Container from "~/components/layout/Container";
import { getValidatedFormData } from "~/lib/remix-hook-form";
import { siteTitle } from "../_index";
import OfferBanner from "../features/OfferBanner";
import References from "../features/References";
import ContactSection from "./features/Contact";
import { type ContactFormSchemaType, ContactResolver } from "./features/contact.schemas";

export async function action({ request }: ActionFunctionArgs) {
  console.log('iletisim formu gonderildi')

  const { errors, data } = await getValidatedFormData<ContactFormSchemaType>(request, ContactResolver)
  if (errors) {
    return json({
      success: false,
      data: 'hata',
    })
  }
  const html = `
    <h1>İletişim Formu</h1>
    <p>Firma Adı: ${data?.firmaAdi}</p>
    <p>Ad Soyad: ${data?.adSoyad}</p>
    <p>Telefon: ${data?.telefon}</p>
    <p>Konu: ${data?.konu}</p>
    <p>Email: ${data?.email}</p>
    <p>Mesaj: ${data?.mesaj}</p>
    `
  const frmdata = new FormData();
  frmdata.append("from", 'UTBSupport iletisim formu <mail@utbsupport.com>');
  frmdata.append("to", "safakbekir@yandex.com");
  frmdata.append("subject", "İletişim Formu");
  frmdata.append("text", "İletişim Formu");
  frmdata.append("html", html);

  // console.log('mailgun', Object.fromEntries(frmdata.entries()))

  let result = false
  const auth = `Basic ${Buffer.from(
    'api:9e57433c0a82d5320d472b6f82abfeea-f3238714-56b523ca',
  ).toString('base64')}`

  console.log('mailgun auth', auth)

  const results = await fetch('https://api.eu.mailgun.net/v3/mail.utbsupport.com/messages', {
    method: 'POST',
    headers: {
      Authorization: auth
    },
    body: frmdata
  })
    .then((response) => {
      console.log('mailgun response', response)
      return response.json() as Promise<{ id?: string, message?: string }>
    })
    .then((sonuc) => {
      console.log('mailgun sonuc aldim', sonuc)
      if (sonuc?.id) {
        result = true
        return json({
          success: true,
          data: 'basarili',
        })
      }
      result = false
      return json({
        success: false,
        data: 'basarisiz',
      })
    })
    .catch((error) => {
      // console.log('mailgun hata', Object.fromEntries(error))
      return json({
        success: false,
        data: 'hata',
      })
    })
  console.log('mailgun sonuc', results)
  return json({
    success: result,
    data: result ? 'basarili' : 'basarisiz',
  })

}
export const meta = () => {
  return [{
    title: `İletişim Bİlgileri ve İletişim Formu | ${siteTitle}`,
  }]
}
export default function Iletisim() {
  return (
    <div className="pt-[122px]">
      <div className="header bg-[#efefef]">
        <Container>
          <h1 className="font-raleway uppercase text-[28px] py-12 w-full font-bold">İletişim</h1>
        </Container>
      </div>
      <div className="bg-white">
        <Container className="flex-wrap">
          <ContactSection />
        </Container>
      </div>
      <OfferBanner />
      <References />
    </div>
  )
}
